// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"19288":"39477768e0","66586":"e2ba0d4cce","67064":"fb5940289a","94965":"33353af58b"}[chunkId] + ".css";
};